import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sectionContainer: ({ variant }) => ({
    gap: theme.spacing(2),
    width: '100%',
    margin: variant === 'modal' ? theme.spacing(8, 0, 0) : theme.spacing(4, variant === 'policy' ? 0 : 4)
  }),
  sectionHeader: { width: '100%' },
  card: ({ variant }) => ({
    padding: theme.spacing(variant === 'modal' ? 4 : 8),
    width: '100%',
    backgroundColor: variant === 'modal' ? theme.colorPalette.beige_40 : theme.colorPalette.beige_25,
    boxShadow: variant === 'modal' ? 'none' : undefined
  }),
  // Matches the review section's card title in the UW questions modal.
  cardTitle: {
    color: theme.colorPalette.green_80,
    fontSize: 20,
    fontWeight: 400,
    marginBottom: theme.spacing(2)
  },
  textareaField: {
    width: '100%'
  }
});

export default makeStyles(styles);
